import React from "react";
import "./design-participated-challenge-item.css";
import { rankingOrder, capitalizeAll } from "../../../../core/utils/helpers";
import { FaUsers } from "react-icons/fa";
import { MdQuiz } from "react-icons/md";
import { GoClock } from "react-icons/go";
import moment from "moment";

const DesignParticipatedChallengeItem = ({
  is_designed_challenge,
  data,
  onAction,
}) => {
  const ranking = data?.ranking;
  const total_points = data?.total_points;
  const challenge_type = data?.challenge_type;
  const challenge_title = data?.challenge_title;
  const total_questions = data?.total_questions;
  const challenge_dates = data?.challenge_dates;

  return (
    <div
      className="design-participated-challenge-item"
      onClick={() => onAction()}
    >
      {is_designed_challenge ? (
        <div className="stick-banner">
          <img
            src={process.env.PUBLIC_URL + "/logo.png"}
            className="logo"
            alt="pamoja for machine intelligence logo"
          />
        </div>
      ) : (
        <span className="stick">
          {ranking} <sup>{rankingOrder(ranking)}</sup> Place
        </span>
      )}
      <div className="design-participated-challenge-item-details">
        <h3>{total_points} Points</h3>
        <h4>{capitalizeAll(challenge_title)}</h4>
        <div className="row">
          <div>
            <FaUsers className="icon" />
            <span>{challenge_type}</span>
          </div>
          <div>
            <MdQuiz className="icon" />
            <span>
              {total_questions} {total_questions > 1 ? "Questions" : "Question"}
            </span>
          </div>
        </div>
        <p>
          <GoClock className="icon" />
          <span>Edited {moment(challenge_dates).fromNow()}</span>
        </p>
      </div>
    </div>
  );
};

export default DesignParticipatedChallengeItem;
